import { render, staticRenderFns } from "./threeStaffList.vue?vue&type=template&id=8ba83052&scoped=true"
import script from "./threeStaffList.vue?vue&type=script&lang=js"
export * from "./threeStaffList.vue?vue&type=script&lang=js"
import style0 from "./threeStaffList.vue?vue&type=style&index=0&id=8ba83052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba83052",
  null
  
)

export default component.exports